/* eslint-disable function-paren-newline */
/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
import React from 'react';
import withPageWrapper from '../../components/Shared/HOCs/withPageWrapper';
import Filters from '../../components/OneSongWonders/Filters';
import useListWonderLines from '../../hooks/OneSongWonder/useListWonderLines';
import useStores from '../../player/hooks/useStores';
import useGetSongForPlayer from '../../hooks/Song/useGetSongForPlayer';
import {
  playerActive,
  toggleFullScreenFromIndex,
} from '../../utils/reactiveVars';

const OneSongWonders = () => {
  const { loading, data, setValue, value } = useListWonderLines();
  const { mediaPlayerStore } = useStores();
  const { getSongRequest } = useGetSongForPlayer({
    guest: false,
  });

  return (
    <>
      <div className="main__container d-flex flex-col align-items-start justify-center py-4 px-md-5 mt-0 wonders__hero">
        <img
          src="/img/wonder-hero-icon.svg"
          alt="Hero icon"
          className="wonders__hero__icon mr-2"
        />
        <h2 className="wonders__hero__copy">
          A fresh approach to Collective Worship that starts with a song and
          encourages spiritual flourishing. One-Song Wonders help children and
          adults to find fullness of life through gospel-inspired wondering
          together.
        </h2>
      </div>
      <Filters
        handleFilterSongs={(filterData) => {
          if (filterData?.filtered) {
            setValue(filterData.filtered[0].formatted_name);
          } else {
            setValue('');
          }
        }}
      />
      <div className="main__container wonders__song-list">
        {!loading &&
          data &&
          data.listWonderLines
            .filter(
              (wonderLine, index, self) =>
                index ===
                self.findIndex((w) => w.song.title === wonderLine.song.title)
            )
            .sort((a, b) =>
              value ? 0 : a.song.title.localeCompare(b.song.title)
            )
            .map((wonderLine) => (
              <button
                className="wonders__song-list__item flex flex-row align-start justify-start gap-4"
                key={wonderLine.songLine}
                onClick={async () => {
                  if (
                    mediaPlayerStore.ready &&
                    mediaPlayerStore.song.id === wonderLine.song.id
                  ) {
                    mediaPlayerStore.setPlaying(false);
                  } else {
                    mediaPlayerStore.setPlaying(false);
                    getSongRequest(wonderLine.song.id);
                  }
                  playerActive(true);
                  mediaPlayerStore.setShowOSW(true);
                  mediaPlayerStore.setShowSlide(false);

                  // Opening a wonder should stay in-browser, without native fullscreen takeover.
                  toggleFullScreenFromIndex(false);
                }}
              >
                <div className="wonders__song-list__item-inner">
                  <img
                    className="wonders__song-list__item__cover"
                    src={wonderLine.song.albumArt}
                    alt="Time for everything cover 1"
                  />
                  <div className="wonders__song-list__item__info w-full p-4 text-left">
                    <h4>{wonderLine.song.title}</h4>
                    <p>{wonderLine.song.songWonderDescription}</p>
                  </div>
                  {wonderLine.isBigWonder && (
                    <div className="wonders__big-wonder-ribbon">
                      <img src="/big-wonder-ribbon.svg" alt="ribbon" />
                      <span>Big</span>
                      <span>Wonder</span>
                    </div>
                  )}
                </div>
              </button>
            ))}
      </div>
    </>
  );
};

export default withPageWrapper({ pageTitle: 'One-Song Wonders | Sparkyard' })(
  OneSongWonders
);
